module.exports = __webpack_public_path__ + "img/sales.4a4daccf.svg";